import Download from './Download'

export default Download
// eslint-disable-next-line import/export
export * from './Download'
